import { InfrontSDK, InfrontUtil } from "@infront/sdk";
import { getInfrontSDKSnapshot } from "./infrontSDK";
import {
  setFlagSimpleStore,
  setIsinSimpleStore,
  setNameSimpleStore,
  setTickerSimpleStore,
} from "@portal/externalStore/infrontAllStocksSimpleStore";
import { trackMessage } from "@portal/appInsights";

export const subscribeToFeed = (feedId: number) => {
  const { instance: sdkInstance, isReady } = getInfrontSDKSnapshot();
  if (!sdkInstance || !isReady) return;

  sdkInstance.get(
    InfrontSDK.feedContents({
      feed: feedId,
      subscribe: false,
      contentType: InfrontSDK.FeedContentType.SymbolData,
      onData: (data: InfrontUtil.ObservableArray<InfrontSDK.SymbolData>) => {
        data.observe(
          {
            reInit: (items: InfrontSDK.SymbolData[]) => {
              items.forEach((item, index) => {
                item.observe(InfrontSDK.SymbolField.Ticker, (value: number | string) => {
                  setTickerSimpleStore(index, feedId, value as string);
                });
                item.observe(InfrontSDK.SymbolField.ISIN, (value: number | string) => {
                  if (value) {
                    setIsinSimpleStore(index, feedId, value as string);
                  }
                });
                item.observe(InfrontSDK.SymbolField.FullName, (value: number | string) => {
                  setNameSimpleStore(index, feedId, value as string);
                });
                item.observe(InfrontSDK.SymbolField.CountryFlag, (value: number | string) => {
                  setFlagSimpleStore(index, feedId, value as string);
                });
              });
            },
          },
          2,
        );
      },
      onError: (error: unknown) => {
        if (typeof error === "string") {
          trackMessage(`Infront SDK SymbolData subscribeToFeed error for ${feedId} error=${error}`);
          console.error(`Infront SDK SymbolData subscribeToFeed error for ${feedId} error`, error);
          return;
        }
        trackMessage(`Infront SDK SymbolData subscribeToFeed error for ${feedId} error=${JSON.stringify(error)}`);
        console.error(`Infront SDK SymbolData subscribeToFeed error for ${feedId} error`, error);
      },
    }),
  );
};
